/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext, useContext } from "react";

export interface AppListContextValues {
  removeAppInstallation: (installationId: string) => void;
  retryAppInstallation: (installationId: string) => void;
}

export const AppListContext = createContext<AppListContextValues | undefined>(undefined);

export const useAppListContext = () => {
  const context = useContext(AppListContext);

  if (!context) {
    throw new Error("useAppListContext must be used within a AppListContext");
  }

  return context;
};
